<template>
  <section class="h_16">
    <m-video
      ref="video"
      class="video_size"
      muted
      autoplay
      loop
      disablepictureinpicture
      x5-playsinline
      playsinline
      webkit-playsinline="true"
      src="@/v2/mobile/assets/video/v_16.mp4"
      poster="@/v2/mobile/assets/video/poster/v_16.webp"
    />
    <div class="content">
      <div class="title f-center-title">物理仿真</div>
      <div class="title f-center-title">动效轻盈又灵动</div>
      <div class="sub_title f-center-sub-title">
        系统控件的动效反馈加入更多物理仿真的特性，如进度条拖动到尽头时再往外扯，模拟橡皮筋被拉长效果，使虚拟界面更直观，更有真实感
      </div>
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5 } from '@/utils'
export default {
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const video = this.$refs.video
    video && videoPlayByVisibleAreaH5(video)
  },
}
</script>

<style lang="less" scoped>
.h_16 {
  width: 100%;
  position: relative;
  video {
    width: 100%;
    position: relative;
  }
  .content {
    position: absolute;
    margin: 0 24px;
    top: 9%;
    .title {
      font-weight: 700;
      line-height: 1.5;
    }
    .sub_title {
      margin-top: 20px;
      line-height: 1.5;
      z-index: 10;
      color: #00000080;
    }
  }
  .f-center-title {
    font-size: 26px;
  }
  .f-center-sub-title {
    font-size: 14px;
  }
}
</style>
